import NavBar from "@/pages/home/components/NavBar";
import Hero from "@/pages/home/components/Hero";
import Synopsis from "@/pages/home/components/Synopsis";
import Formats from "@/pages/home/components/Formats";
import ContentLibrary from "@/pages/home/components/ContentLibrary";
import Characters from "@/pages/home/components/Characters";
import WatchGuide from "@/pages/home/components/WatchGuide";
import Updates from "@/pages/home/components/Updates";
import Faq from "@/pages/home/components/Faq";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-800">
      <NavBar />
      <main>
        <Hero />
        <Synopsis />
        <Formats />
        <ContentLibrary />
        <Characters />
        <WatchGuide />
        <Updates />
        <Faq />
      </main>
      <SiteFooter />
    </div>
  );
}